<template>
  <guest-layout>
    <template #header>
      Penerima Beasiswa Cilegon Juare
    </template>
    <Head title="Penerima Beasiswa Cilegon Juare" />
    <div class="container flex flex-wrap justify-between p-6 mx-auto my-4 mt-6 max-w-8xl">
      <div class="w-full bg-white rounded-md shadow">
        <search-filter v-model="form.search" class="w-full max-w-lg m-4" @reset="reset" />
        <div class="p-6">
          <table class="w-full text-sm divide-y divide-gray-200">
            <thead>
              <tr class="font-bold text-left">
                <th class="px-6 pt-6 pb-4">No. </th>
                <th class="px-6 pt-6 pb-4">Nama </th>
                <th class="hidden px-6 pt-6 pb-4 md:table-cell">Nama Perguruan Tinggi</th>
                <th class="hidden px-6 pt-6 pb-4 md:table-cell">Nama Program Studi</th>
              </tr>
            </thead>
            <tbody v-if="applicants && applicants.data && applicants.data.length > 0">
              <tr v-for="(applicant, index) in applicants.data" :key="applicant.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="p-4 border-t">
                  {{ (applicants.current_page - 1) * applicants.per_page + index + 1 }}
                </td>
                <td class="p-4 border-t">
                  {{ applicant.nama }}
                </td>
                <td class="hidden p-4 border-t md:table-cell">
                  {{ applicant.nama_universitas }}
                </td>
                <td class="hidden p-4 border-t md:table-cell">
                  {{ applicant.nama_prodi }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="px-6 py-4 text-center border-t" colspan="5">Belum ada data penerima beasiswa.</td>
              </tr>
            </tbody>
            <tbody>
              <tr v-if="unverified > 0">
                <th class="px-6 py-4 text-center text-red-800 border-t " colspan="5">Terdapat {{ unverified }} data pendaftar yang belum diverifikasi.</th>
              </tr>
              <tr v-if="unfinished > 0">
                <th class="px-6 py-4 text-center text-red-800 border-t " colspan="5">Terdapat {{ unfinished }} data pendaftar yang belum difinalisasi.</th>
              </tr>
            </tbody>
          </table>
          <pagination v-if="applicants && applicants.data && applicants.data.length > 0" class="m-4" :links="applicants.links" />
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import GuestLayout from '@/Layouts/GuestLayout.vue'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'

export default {
  components:{
    GuestLayout,
    Pagination,
    Head,
    SearchFilter,
  },
  props: {
    applicants: Object,
    unverified: Number,
    unfinished: Number,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/hasil-seleksi', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>

<style>

</style>
